import AmountGroupTitle from './AmountGroupTitle';

export default AmountGroupTitle;
